import moment from "moment";
import {
    getTimeStorageTimezone,
    substractTimeToStorageTimeZone,
} from "./custom-time-fns";

export const createSelectedPeriodState = (
    nextPeriod,
    prevTypeGraph,
    statePeriod = null
) => {
    const {
        yearEnd,
        monthEnd,
        dayEnd,
        hoursEnd,
        minutesEnd,
        secondsEnd,
    } = getTimeStorageTimezone();
    const {
        year,
        month,
        day,
        hours,
        minutes,
        seconds,
    } = substractTimeToStorageTimeZone(1, "hour");
    // selectedPeriodState son los nuevos datos del state para actualizar los datos
    var selectedPeriodState = {
        nextPeriod,
        typeGraph: prevTypeGraph,
        isStatePeriod: false,
        periodEl: null,
        isRefresh: false,
        periodText: nextPeriod,
        chartOptionsStackedBarConsolidated: {
            series: [
                {
                    data: [
                        {
                            x: Date.UTC(
                                year,
                                month,
                                day,
                                hours,
                                minutes,
                                seconds
                            ),
                            x2: Date.UTC(
                                yearEnd,
                                monthEnd,
                                dayEnd,
                                hoursEnd,
                                minutesEnd,
                                secondsEnd
                            ),
                            y: 0,
                            color: "white",
                        },
                    ],
                },
            ],
        },
    };

    if (nextPeriod === "hora") {
        const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
        } = substractTimeToStorageTimeZone(1, "hour");

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "h",
            typePeriod: 0,
            periodText: nextPeriod,
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: Date.UTC(
                                    year,
                                    month,
                                    day,
                                    hours,
                                    minutes,
                                    seconds
                                ),
                                x2: Date.UTC(
                                    yearEnd,
                                    monthEnd,
                                    dayEnd,
                                    hoursEnd,
                                    minutesEnd,
                                    secondsEnd
                                ),
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
        };
    } else if (nextPeriod === "3hora") {
        const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
        } = substractTimeToStorageTimeZone(3, "hour");

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "3h",
            typePeriod: 1,
            periodText: nextPeriod,
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: Date.UTC(
                                    year,
                                    month,
                                    day,
                                    hours,
                                    minutes,
                                    seconds
                                ),
                                x2: Date.UTC(
                                    yearEnd,
                                    monthEnd,
                                    dayEnd,
                                    hoursEnd,
                                    minutesEnd,
                                    secondsEnd
                                ),
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
        };
    } else if (nextPeriod === "6hora") {
        const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
        } = substractTimeToStorageTimeZone(6, "hour");

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "6h",
            typePeriod: 2,
            periodText: nextPeriod,
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: Date.UTC(
                                    year,
                                    month,
                                    day,
                                    hours,
                                    minutes,
                                    seconds
                                ),
                                x2: Date.UTC(
                                    yearEnd,
                                    monthEnd,
                                    dayEnd,
                                    hoursEnd,
                                    minutesEnd,
                                    secondsEnd
                                ),
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
        };
    } else if (nextPeriod === "12hora") {
        const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
        } = substractTimeToStorageTimeZone(12, "hour");

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "12h",
            typePeriod: 3,
            periodText: nextPeriod,
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: Date.UTC(
                                    year,
                                    month,
                                    day,
                                    hours,
                                    minutes,
                                    seconds
                                ),
                                x2: Date.UTC(
                                    yearEnd,
                                    monthEnd,
                                    dayEnd,
                                    hoursEnd,
                                    minutesEnd,
                                    secondsEnd
                                ),
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
        };
    } else if (nextPeriod === "dia") {
        const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
        } = substractTimeToStorageTimeZone(1, "day");

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "d",
            typePeriod: 4,
            periodText: nextPeriod,
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: Date.UTC(
                                    year,
                                    month,
                                    day,
                                    hours,
                                    minutes,
                                    seconds
                                ),
                                x2: Date.UTC(
                                    yearEnd,
                                    monthEnd,
                                    dayEnd,
                                    hoursEnd,
                                    minutesEnd,
                                    secondsEnd
                                ),
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
        };
    } else if (nextPeriod === "2dia") {
        const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
        } = substractTimeToStorageTimeZone(2, "day");

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "2d",
            typePeriod: 5,
            periodText: nextPeriod,
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: Date.UTC(
                                    year,
                                    month,
                                    day,
                                    hours,
                                    minutes,
                                    seconds
                                ),
                                x2: Date.UTC(
                                    yearEnd,
                                    monthEnd,
                                    dayEnd,
                                    hoursEnd,
                                    minutesEnd,
                                    secondsEnd
                                ),
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
        };
    } else if (nextPeriod === "semana") {
        const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
        } = substractTimeToStorageTimeZone(7, "day");

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "w",
            typePeriod: 6,
            periodText: nextPeriod,
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: Date.UTC(
                                    year,
                                    month,
                                    day,
                                    hours,
                                    minutes,
                                    seconds
                                ),
                                x2: Date.UTC(
                                    yearEnd,
                                    monthEnd,
                                    dayEnd,
                                    hoursEnd,
                                    minutesEnd,
                                    secondsEnd
                                ),
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
        };
    } else if (nextPeriod === "2semana") {
        const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
        } = substractTimeToStorageTimeZone(14, "day");

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "2w",
            typePeriod: 7,
            periodText: nextPeriod,
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: Date.UTC(
                                    year,
                                    month,
                                    day,
                                    hours,
                                    minutes,
                                    seconds
                                ),
                                x2: Date.UTC(
                                    yearEnd,
                                    monthEnd,
                                    dayEnd,
                                    hoursEnd,
                                    minutesEnd,
                                    secondsEnd
                                ),
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
        };
    } else if (nextPeriod === "mes") {
        //Obtener cantidad de que transcurriendo desde el mes anterior
        const hoy = new Date();
        const mesPasado = new Date();
        mesPasado.setMonth(hoy.getMonth() - 1);
        const diferencia = hoy.getTime() - mesPasado.getTime();
        const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));

        const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
        } = substractTimeToStorageTimeZone(dias, "day");

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "m",
            typePeriod: 8,
            periodText: nextPeriod,
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: Date.UTC(
                                    year,
                                    month,
                                    day,
                                    hours,
                                    minutes,
                                    seconds
                                ),
                                x2: Date.UTC(
                                    yearEnd,
                                    monthEnd,
                                    dayEnd,
                                    hoursEnd,
                                    minutesEnd,
                                    secondsEnd
                                ),
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
        };
    } else if (nextPeriod === "custom" || nextPeriod === "c") {
        const startDate = moment.utc(statePeriod.startDate).valueOf();
        const endDate = moment.utc(statePeriod.endDate).valueOf();

        selectedPeriodState = {
            ...selectedPeriodState,
            period: "c",
            typePeriod: 9,
            periodText:
                "Rango: " +
                moment(statePeriod.startDate).format("YYYY-MM-DD") +
                " a " +
                moment(statePeriod.endDate).add("days", 1).format("YYYY-MM-DD"),
            chartOptionsStackedBarConsolidated: {
                series: [
                    {
                        data: [
                            {
                                x: startDate,
                                x2: endDate,
                                y: 0,
                                color: "white",
                            },
                        ],
                    },
                ],
            },
            statePeriod,
        };
    }

    return selectedPeriodState;
};

const statePeriod = {
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
};

export const defaultPeriodsGeneralStatus = [
    {
        value: "hora",
        text: "Última hora",
        typePeriod: 0,
        period: "hora",
        statePeriod,
    },
    {
        value: "3hora",
        text: "Últimas 3 horas",
        typePeriod: 1,
        period: "3hora",
        statePeriod,
    },
    {
        value: "6hora",
        text: "Últimas 6 horas",
        typePeriod: 2,
        period: "6hora",
        statePeriod,
    },
    {
        value: "12hora",
        text: "Últimas 12 horas",
        typePeriod: 3,
        period: "12hora",
        statePeriod,
    },
    {
        value: "dia",
        text: "Último día",
        typePeriod: 4,
        period: "dia",
        statePeriod,
    },
    {
        value: "2dia",
        text: "Últimos 2 días",
        typePeriod: 5,
        period: "2dia",
        statePeriod,
    },
    {
        value: "semana",
        text: "Última semana",
        typePeriod: 6,
        period: "semana",
        statePeriod,
    },
    {
        value: "2semana",
        text: "Últimas 2 semanas",
        typePeriod: 7,
        period: "2semana",
        statePeriod,
    },
    {
        value: "mes",
        text: "Último mes",
        typePeriod: 8,
        period: "mes",
        statePeriod,
    },
];
